import React from "react";
import { StyledBadge, StyledAnchor, StyledList } from "./_.styled";
import { Popover, Type } from "@ebscois/react-component-library";

const mapLevelToTooltipText = (loe) => {
  return (
    <>
      {typeof loe.info === "string" ? (
        <Type element="p" fontSize="xs">
          <strong>{loe.title}</strong> {loe.info}
        </Type>
      ) : (
        <>
          <Type element="p" fontSize="xs">
            <strong>{loe.title}</strong>
          </Type>
          <StyledList type="ul">
            {loe.info.map((infoElement) => {
              return <li>{infoElement}</li>;
            })}
          </StyledList>
        </>
      )}
    </>
  );
};

const EvidenceToolTip = ({
  badgeText,
  loeLevel,
  setIsEvidenceBottomSheetOpen,
  loe,
}) => {
  if (!loeLevel) {
    return null;
  }
  return (
    <>
      <Popover
        placement="right"
        toggle="hover"
        trigger={
          <StyledBadge
            element="button"
            variant="secondary"
            fontFamily="primary"
            children={badgeText}
            count={loeLevel}
          />
        }
        popperComponentProps={{
          variant: "primary",
          width: "medium",
        }}
      >
        <Type data-testid="evidence-tooltip">
          {mapLevelToTooltipText(loe.levels[loeLevel - 1])}
        </Type>
        <StyledAnchor
          onClick={(event) => {
            event.preventDefault();
            setIsEvidenceBottomSheetOpen(true);
          }}
          data-testid="evidence-tooltip-anchor"
        >
          Learn more about DynaMed's levels of evidence
        </StyledAnchor>
      </Popover>
    </>
  );
};

EvidenceToolTip.displayName = "EvidenceToolTip";

export default EvidenceToolTip;
